const URLs = {
  ROOT: '/',
  Login: '/login',
  Auth: '/openid-connect/forgerock',
  NewPlan: 'new-plan/:year?/:quarter?/:planId?',
  HistoricalData: 'historical-data',
  KpiResults: 'kpi-results/:inputId/:year/:quarter/:planId?',
  ActionPlan: 'action-plan/:planId/:completed?',
  Salon: '/salon/:salonId',
  SalonAfterPlanSent: '/salon/:salonId/:sent',
  SalonDashboard: '/salon-dashboard/:salonId?',
  SdpDashboard: '/sdp-dashboard',
  LeadershipDashboard: '/leadership-dashboard',
  SdpSummaryDashboard: '/sdp-summary-dashboard',
} as const;

export default URLs;
